var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeisure02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.726562,
    y: 0.529297,
    width: 350,
    height: 233,
    fill: "#4A5294"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.719 71.3809C261.719 70.8286 262.166 70.3809 262.719 70.3809H265.42C265.972 70.3809 266.42 70.8286 266.42 71.3809V146.308H261.719V71.3809Z",
    fill: "#E77F45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.068 72.418L300.817 118.354C301.242 118.885 301.024 119.676 300.387 119.915L264.068 133.534V72.418Z",
    fill: "#783E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.068 74.7695L293.958 118.455C294.308 118.966 294.114 119.668 293.552 119.927L264.068 133.535V74.7695Z",
    fill: "#EFA278"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.719 81.8223L241.065 127.545C240.806 128.12 241.137 128.79 241.752 128.931L261.719 133.536V81.8223Z",
    fill: "#FFE9DD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M261.719 81.8223L261.607 84.2235L259.361 132.501L261.719 133.536V81.8223Z",
    fill: "#EAB191"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.514 151.131C217.927 150.53 218.298 149.518 219.134 149.437L309.109 140.78C309.926 140.701 310.484 141.586 310.062 142.29L297.269 163.611C297.089 163.912 296.763 164.096 296.412 164.096H231.582C231.312 164.096 231.054 163.987 230.866 163.794L218.514 151.131Z",
    fill: "#E77F45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.108 140.78L245.264 146.928C274.327 155.026 285.176 155.597 301.638 156.328L310.061 142.29C310.484 141.586 309.925 140.701 309.108 140.78Z",
    fill: "#783E1E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeisure02);
export default __webpack_public_path__ + "static/media/leisure_02.6ea8dddd55722385d89f7bdd3bdb846a.svg";
export { ForwardRef as ReactComponent };